import { NAME } from './constants';

export const INVALIDATE_CACHE = `${NAME}.INVALIDATE_CACHE`;
export const CLEAR_CACHE = `${NAME}.CLEAR_CACHE`;

export const FETCH_START = `${NAME}.FETCH_START`;
export const FETCH_SUCCESS = `${NAME}.FETCH_SUCCESS`;
export const FETCH_ERROR = `${NAME}.FETCH_ERROR`;
